export default {
  'express-checkout:page-title': 'Complete order',
  'express-checkout:cart-items:size': 'Size',
  'express-checkout:cart-items:remove': 'Remove',
  'express-checkout:header': 'Do you really want to cancel your purchase and return to the cart?',
  'express-checkout:header:button-continue': 'Continue shopping',
  'express-checkout:header:button-to-cart': 'To cart',
  'express-checkout:summary-prices:not-use-discount': 'Do not use',
  'express-checkout:summary-prices:use-discount': 'Use',
  'express-checkout:confirm:error-message': 'Oops – something went wrong during payment.',
  'express-checkout:confirm:thank-you-message:header': 'Thank you for your order',
  'express-checkout:confirm:thank-you-message:sub-header':
    "We'll let you know as soon as your order is on its way.",
  'express-checkout:confirm:button-continue-shopping': 'Continue browsing',
  'express-checkout:summary-form:shipping-and-payment:shipping': 'Expected delivery',
  'express-checkout:summary-form:shipping-and-payment:extra-options': 'Additional options',
  'express-checkout:summary-form:shipping-and-payment:eco-option': 'Eco Option',
  'express-checkout:summary-form:shipping-and-payment:eco-option-point-1':
    'Environmentally friendly insulating packaging made from recycled PET wool',
  'express-checkout:summary-form:shipping-and-payment:eco-option-point-2':
    'Sustainable and fully recyclable',
  'express-checkout:summary-form:re-auth-loading-message':
    'Hang tight – this might take a few seconds.',
  'express-checkout:summary-form:addresses:complete-address':
    'Please complete the address before paying.',
};
